import { useCallback } from 'react'
import { useCaptcha } from '../useCaptcha/useCaptcha'

/*
  Captcha for every flow that submits to POST /v1/store/applications (Smart Apply,
  Native Apply). Unflagged on the front end - the whole apply flow already sits behind
  cp_partner_apply_enabled, and the API only enforces the token behind be_store_applications_captcha,
  so sending it unconditionally is safe while that gate rolls out.
*/
export function useApplicationsCaptcha() {
  const { recaptchaRef, executeCaptcha, isVerifying, isSlow } = useCaptcha('applications')

  const getCaptchaToken = useCallback(async () => {
    try {
      const token = await executeCaptcha()

      return token ?? undefined
    } catch {
      // Submitting without a token leaves the decision to the API, which rejects it once
      // be_store_applications_captcha is on and accepts it while the gate is off.
      return undefined
    }
  }, [executeCaptcha])

  return { recaptchaRef, getCaptchaToken, isVerifying, isSlow }
}
